import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import {
  SyncDateRange,
  SyncDateRangePicker,
} from '../sync-date-range';

type SyncAccountDialogProps = {
  open: boolean;
  accountName: string | null;
  providerName: string | null;
  syncing: boolean;
  dateRange: SyncDateRange;
  onDateRangeChange: (value: SyncDateRange) => void;
  onClose: () => void;
  onConfirm: () => void;
};

export function SyncAccountDialog({
  open,
  accountName,
  providerName,
  syncing,
  dateRange,
  onDateRangeChange,
  onClose,
  onConfirm,
}: SyncAccountDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={syncing ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      data-testid="cloud-account-sync-dialog">
      <DialogTitle>Sync cloud account</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {providerName ?? 'Account'}: {accountName ?? '—'}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Schedule synchronization for all subscriptions in this account.
          Optionally limit the cost sync to a specific date range.
        </Typography>
        <SyncDateRangePicker
          value={dateRange}
          onChange={onDateRangeChange}
          compact
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={syncing}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={syncing}
          data-testid="cloud-account-sync-confirm">
          {syncing ? 'Scheduling…' : 'Schedule sync'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
